<boi-form-numeric-input
  [labelName]="
    mortgageApplication.isBuyToLet
      ? referenceDataLabels.NumberOfDependentsBTL
      : referenceDataLabels.NumberOfDependentsId
  "
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [(value)]="mortgageApplication.Applicants[0].NumberOfDependants"
  [propertyNames]="['Applicant_0.NumberOfDependants']"
  [contextualHelpName]="
    mortgageApplication.isBuyToLet ? referenceDataLabels.NumberOfDependentsBTL : 'AppNoOfDependants'
  "
  (valueChange)="mortgageApplication.initializeDependants()"
  [fieldMaxLength]="2"
>
</boi-form-numeric-input>

<ng-container *ngIf="mortgageApplication.Applicants[0].NumberOfDependants > 0">
  <ng-container
    *ngFor="let dependant of mortgageApplication.Applicants[0].ApplicantDependants; index as dependantIndex"
  >
    <boi-form-numeric-input
      [fieldMaxLength]="3"
      [labelName]="referenceDataLabels.AgeOfFinancialDependant"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelIndex]="dependantIndex + 1"
      [controlId]="referenceDataLabels.AgeOfFinancialDependant + dependantIndex"
      [propertyNames]="['Applicant_0.ApplicantDependant_' + dependantIndex + '.' + 'Age']"
      [(value)]="dependant.Age"
    >
    </boi-form-numeric-input>
  </ng-container>
</ng-container>

<!-- 132 & 134 -->
<ng-container *ngIf="mortgageApplication?.IsFullApp && mortgageApplication?.isBuyToLet">
  <boi-form-numeric-input
    [labelName]="referenceDataLabels.HowManyBtlWithUs"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [(value)]="mortgageApplication.HowManyBtlWithUs"
    (valueChange)="onHowManyBtlChanged()"
    [propertyNames]="['HowManyBtlWithUs']"
    [contextualHelpName]="'AppOtherBtlWithUsDetails'"
    [fieldMaxLength]="3"
  >
  </boi-form-numeric-input>

  <ng-container *ngIf="areBtlAdditionalFieldsVisible">
    <boi-form-numeric-input
      [isCurrency]="true"
      [labelName]="referenceDataLabels.TotalLoanAmounts"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [(value)]="mortgageApplication.BtlWithUsTotalOutstandingLoanAmount"
      [propertyNames]="['BtlWithUsTotalOutstandingLoanAmount']"
      [fieldMaxLength]="8"
      [fieldMaxValue]="99999999"
    >
    </boi-form-numeric-input>

    <boi-form-textarea
      [labelName]="referenceDataLabels.OtherBtlWithUsDetails"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [propertyNames]="['OtherBtlWithUsDetails']"
      [(value)]="mortgageApplication.OtherBtlWithUsDetails"
      [fieldMaxLength]="1500"
    >
    </boi-form-textarea>
  </ng-container>

  <boi-form-numeric-input
    [labelName]="referenceDataLabels.HowManyBtlInTotal"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [(value)]="mortgageApplication.HowManyBtlInTotal"
    (valueChange)="onHowManyBtlChanged()"
    [propertyNames]="['HowManyBtlInTotal']"
    [contextualHelpName]="'AppHowManyBtlInTotal'"
    [fieldMaxLength]="3"
  >
  </boi-form-numeric-input>

  <ng-container *ngIf="isLoanGroupTypeBtlAffordability">
    <ng-container *ngIf="isTotalBalanceOutstandingBtlMortgageVisible">
      <boi-form-numeric-input
        [isCurrency]="true"
        [labelName]="referenceDataLabels.TotalBalanceOutstandingBtlMortgage"
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [(value)]="mortgageApplication.TotalBalanceOutstandingBtlMortgage"
        [propertyNames]="['TotalBalanceOutstandingBtlMortgage']"
        [fieldMaxLength]="8"
      ></boi-form-numeric-input>
    </ng-container>

    <ng-container *ngIf="isTotalMonthlyRentalIncomeBtlVisible">
      <boi-form-numeric-input
        [isCurrency]="true"
        [labelName]="referenceDataLabels.TotalMonthlyRentalIncomeBtl"
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [(value)]="mortgageApplication.TotalMonthlyRentalIncomeBtl"
        [propertyNames]="['TotalMonthlyRentalIncomeBtl']"
        [fieldMaxLength]="8"
      >
      </boi-form-numeric-input>
    </ng-container>
  </ng-container>
</ng-container>

<div class="outgoings-container">
  <p class="bo-info-text my-15" [innerHtml]="referenceDataLabels.AboutTheOutgoingsDetails | localizeLabel"></p>

  <!-- 148 -->
  <boi-form-checkbox
    [controlId]="referenceDataLabels.NoOutgoingsDeclaration"
    [checkboxLabel]="referenceDataLabels.NoOutgoingsDeclaration | localizeLabel"
    [propertyNames]="['Applicant_0.HasOutgoingsCode']"
    [(value)]="mortgageApplication.HasOutgoingsCode"
    [trueValue]="referenceDataOptionLists.AnswerTypeNo"
    [falseValue]="referenceDataOptionLists.AnswerTypeYes"
    [isFieldDisabled]="
      hasOutgoings || mortgageApplication?.IsFactFindReadOnly || mortgageApplication?.IsApplicationReadOnly
    "
    (valueChange)="updateCannotAddAndSelectOutgoings()"
  >
  </boi-form-checkbox>

  <ng-container *ngFor="let outgoing of outgoings; index as i">
    <div class="outgoing-type vo-panel-grey p-15 px-md-0">
      <div class="outgoing-title d-flex flex-row justify-content-between mx-15">
        <span [innerHtml]="outgoing.DebtOutgoingTypeCode | localizeOption : referenceDataOptionLists.DebtType"></span>
        <button
          class="remove-button vo-icon vo-icon-recycle-bin cursor-pointer"
          (click)="deleteOutgoing(outgoing, i)"
          [disabled]="mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly"
        ></button>
      </div>

      <boi-applicant-outgoing [index]="i" [outgoing]="outgoing" [mortgageApplication]="mortgageApplication">
      </boi-applicant-outgoing>
    </div>

    <div class="form-element">
      <a
        class="link vo-link my-15 d-block"
        [ngClass]="{ disabled: mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly }"
        (click)="addNewOutgoing(outgoing.DebtOutgoingTypeCode)"
        [innerHtml]="
          referenceDataLabels.OutgoingAddAnother
            | localizeLabel
            | formatString : [outgoing.DebtOutgoingTypeCode | localizeOption : referenceDataOptionLists.DebtType]
        "
      ></a>
    </div>
  </ng-container>

  <div [boiPermissionChecker]="[userPermissions.ViewCases]">
    <!-- 155 -->
    <div class="dash-line-top total-outgoings" *ngIf="hasOutgoings">
      <boi-form-numeric-input
        [labelName]="referenceDataLabels.OutgoingsTotal"
        [isCurrency]="true"
        [value]="outgoingsTotal"
        [isFieldDisabled]="true"
      ></boi-form-numeric-input>
    </div>
    <!-- 155.1 & 155.2 -->
    <ng-container *ngIf="mortgageApplication.ContinuingMonthlyPayments">
      <boi-form-numeric-input
        [labelName]="referenceDataLabels.MonthlyOutgoingsDeclared"
        [isCurrency]="true"
        [value]="mortgageApplication.ContinuingMonthlyPayments"
        [isFieldDisabled]="true"
      ></boi-form-numeric-input>
    </ng-container>
  </div>

  <!-- 149 -->
  <boi-validation-error [propertyNames]="['EquityLoan']"></boi-validation-error>
  <div class="add-new-outgoing vo-panel-grey p-15 pl-md-0 d-flex my-15">
    <boi-form-option-list
      [optionList]="referenceDataOptionLists.DebtType"
      [contextualHelpName]="!cannotSelectOutgoingType ? referenceDataLabels.AppOutgoingType : ''"
      [labelName]="referenceDataLabels.AddNewOutgoing"
      [(value)]="selectedOutgoingType"
      [isFieldDisabled]="
        cannotSelectOutgoingType || mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly
      "
      (valueChange)="updateCannotAddAndSelectOutgoings()"
    >
    </boi-form-option-list>

    <button
      class="primary-button vo-secondary-button-1 mt-15"
      (click)="addNewOutgoing(selectedOutgoingType)"
      [disabled]="
        cannotAddOutgoing || mortgageApplication.IsApplicationReadOnly || mortgageApplication.IsFactFindReadOnly
      "
      title="{{ referenceDataLabels.Add | localizeLabel }}"
    >
      {{ referenceDataLabels.Add | localizeLabel }}
    </button>
  </div>
</div>
